export const ru = {
    'banner-id': '№ {bannerId}'
};
